import React from 'react';
import TopBar from '../components/TopBar';

const WasteManagement = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="waste-management" userClaims={userClaims} />
      
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="p-6 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-green-100">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
              </svg>
            </div>
            <h3 className="text-lg font-semibold mb-2">Waste Management Module</h3>
            <p className="text-gray-600 mb-4">Reduce, reuse and recycle waste in vaccine supply chain.</p>
            <p className="text-gray-500">This module is under development. Coming soon.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WasteManagement; 